"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casaluce": {
    "b2da68f5": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "skipSearch": false
    }],
    "aprano": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cde0caa7": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "skipSearch": false
    }],
    "piro": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23d7ca9f": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "skipSearch": false
    }],
    "popone": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f94033fc": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "a3e5c28c",
      "slug": "casaluce",
      "name": "Casaluce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;